module.exports = __webpack_public_path__ + "assets/img/login-phone.fb3f549.png";


//////////////////
// WEBPACK FOOTER
// ./website/assets/login-phone.png
// module id = 3q9L
// module chunks = 50